module.exports = __webpack_public_path__ + "img/stock3.021055b5.png";